/**
 * Sales Control › References switchboard API — fork của getSaleReferenceRows (Sales
 * Contract) sang scope Sales Control. Endpoint BE: GET /sale-control-references/{page_key}.
 */
import { apiSlice } from './apiSlice'
import type { SaleReferencePageResponse } from './saleContractApi'

export type { SaleReferencePageResponse } from './saleContractApi'

export interface SaleControlReferenceRowsQuery {
  pageKey: string
  limit?: number
}

export const saleControlReferenceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSaleControlReferenceRows: builder.query<SaleReferencePageResponse, SaleControlReferenceRowsQuery>({
      query: ({ pageKey, limit = 1000000 }) => ({
        url: `/sale-control-references/${encodeURIComponent(pageKey)}`,
        params: { limit },
      }),
      providesTags: (_r, _e, { pageKey }) => [
        { type: 'SaleControlReference' as const, id: pageKey },
        { type: 'SaleControlReference' as const, id: 'LIST' },
      ],
    }),
  }),
})

export const { useGetSaleControlReferenceRowsQuery } = saleControlReferenceApi
